import BeeBreadcrumbs from '@/components/BeeBreadcrumbs.vue';
import Editor from '@/components/Editor.vue';
import BeeDropImg from '@/components/BeeDropImg.vue';
import $eventBus, { $snackbar } from '@/event-bus';
export default {
	install(Vue) {
		Vue.prototype.$eventBus = $eventBus;
		Vue.prototype.$snackbar = $snackbar;
		Vue.component('BeeBreadcrumbs', BeeBreadcrumbs);
		Vue.component('Editor', Editor);
		Vue.component('BeeDropImg', BeeDropImg);
	}
}